/**
 * Empathy Search Trigger Component
 * Handles the search icon toggle (search <-> close) and Empathy search open/close
 * Uses vanilla JavaScript for better browser compatibility
 */
class EmpathySearchTrigger {
  constructor(element) {
    this.element = element;
    this.isOpen = false;
    this.preventNextOpen = false; // Flag to prevent immediate re-opening
    this.trigger = element; // Now the trigger is the element itself
    this.searchIcon = element.querySelector('.empathy-icon-search');
    this.closeIcon = element.querySelector('.empathy-icon-close');
    this.headerBrand = document.querySelector('.wt-header__brand');

    this.init();
  }

  init() {
    // Click handler for the trigger element
    if (this.trigger) {
      this.trigger.addEventListener('click', (e) => {
        e.preventDefault();
        // Don't toggle if we're preventing the next open
        if (this.preventNextOpen) {
          return;
        }
        // If clicking on the close icon explicitly, force close
        if (e.target && e.target.closest && e.target.closest('.empathy-icon-close')) {
          this.closeEmpathySearch();
          return;
        }
        this.toggleEmpathySearch();
      });

      // Add keyboard support for Enter and Space keys
      this.trigger.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          // Don't toggle if we're preventing the next open
          if (this.preventNextOpen) {
            return;
          }
          this.toggleEmpathySearch();
        }
      });
    }

    // Global Escape key handler
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' || e.code === 'Escape') {
        if (this.isOpen) {
          this.closeEmpathySearch();
          e.preventDefault();
          e.stopPropagation();
        }
      }
    });
  }

  toggleEmpathySearch() {
    if (this.isOpen) {
      this.closeEmpathySearch();
    } else {
      this.openEmpathySearch();
    }
  }

  openEmpathySearch() {
    if (typeof window.openEmpathySearch === 'function') {
      window.openEmpathySearch();
      this.isOpen = true;
      this.updateIcon(true);
      // Toggle header brand class when search opens
      if (this.headerBrand) {
        this.headerBrand.classList.add('search--open');
      }
    } else {
      console.warn('Empathy openEmpathySearch function is not available');
    }
  }

  closeEmpathySearch() {
    if (typeof window.closeEmpathySearch === 'function') {
      window.closeEmpathySearch();
      this.isOpen = false;
      this.updateIcon(false);
      // Remove focus to avoid outline
      if (this.trigger) {
        this.trigger.blur();
      }
      // Remove header brand class when search closes
      if (this.headerBrand) {
        this.headerBrand.classList.remove('search--open');
      }
      // Prevent immediate re-open on the next click
      this.preventNextOpen = true;
      setTimeout(() => { this.preventNextOpen = false; }, 300);
    } else {
      console.warn('Empathy closeEmpathySearch function is not available');
    }
  }

  updateIcon(isOpen) {
    if (isOpen) {
      // Show close icon, hide search icon
      if (this.searchIcon) this.searchIcon.classList.add('hidden');
      if (this.closeIcon) this.closeIcon.classList.remove('hidden');
    } else {
      // Show search icon, hide close icon
      if (this.searchIcon) this.searchIcon.classList.remove('hidden');
      if (this.closeIcon) this.closeIcon.classList.add('hidden');
    }
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  const empathyTriggerElement = document.querySelector('.empathy-search-trigger');
  if (empathyTriggerElement) {
    window.empathySearchTrigger = new EmpathySearchTrigger(empathyTriggerElement);
  }
});
